import i18n from "@/config/i18n";
export const memberTable = [
  {
    title: i18n.t("operationData.fullName"),
    key: "fullName",
    minWidth: 110
  },
  {
    title: i18n.t("operationData.phoneNo"),
    key: "phoneNo",
    minWidth: 110
  },
  {
    title: i18n.t("operationData.createTime"),
    key: "createTime",
    minWidth: 130
  },
  {
    title: i18n.t("operationData.balanceAmount"),
    key: "balanceAmount",
    minWidth: 100
  },
  {
    title: i18n.t("operationData.chargeTimes"),
    key: "chargeTimes",
    minWidth: 100
  }
];
